import jwtDecode from 'jwt-decode'

import { sessionConstants } from '../constants'

let token = sessionStorage.getItem('token')
let email = ''
let state = ''
let role = ''
let firstName = ''

if (token) {
  email = jwtDecode(token).user_claims.email
  state = jwtDecode(token).user_claims.state
  role = jwtDecode(token).user_claims.role
  firstName = jwtDecode(token).user_claims.first_name
}

const initialState = email
  ? {
      token: token,
      username: email,
      state: state,
      role: role,
      firstName: firstName,
      loading: false,
      isAuthenticated: true,
    }
  : {
      loading: false,
    }

export function session(state = initialState, action) {
  switch (action.type) {
    case sessionConstants.LOGIN_REQUEST:
      return {
        loading: true,
        error: false,
        errors: [],
      }
    case sessionConstants.LOGIN_SUCCESS:
    case sessionConstants.SESSION_UPDATE_SUCCESS:
      return {
        loading: false,
        isAuthenticated: true,
        state: jwtDecode(action.token).user_claims.state,
        role: jwtDecode(action.token).user_claims.role,
        username: jwtDecode(action.token).user_claims.email,
        firstName: jwtDecode(action.token).user_claims.first_name,
        token: action.token,
        error: false,
        errors: [],
      }
    case sessionConstants.LOGIN_FAILURE:
      return {
        loading: false,
        isAuthenticated: false,
        token: null,
        username: null,
        error: true,
        errors: action.errors,
      }
    case sessionConstants.LOGOUT_REQUEST:
    case sessionConstants.LOGOUT_SUCCESS:
      return {
        loading: false,
      }
    default:
      return state
  }
}
